import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

// MSAL_TOGGLE_START
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalRedirectComponent } from '@azure/msal-angular';
// MSAL_TOGGLE_END

//******************************************************************************
//  App Framework
//******************************************************************************
import { AppComponent } from '~/core/app.component';

//******************************************************************************
//  Services
//******************************************************************************
import { AppConfigService } from '~/core/services/appconfig.service';

//******************************************************************************
//  Core Imports
//******************************************************************************
import { CoreImports } from '~/core/classes/imports/core.imports';
import { CoreRouting } from '~/core/classes/routes/core.routing';

//******************************************************************************
//  App Imports
//******************************************************************************
import { AppImports } from '~/classes/imports/app.imports';
import { AppRouting } from '~/classes/routes/app.routing';

//******************************************************************************
//  External Imports
//******************************************************************************
import { ExternalImports } from '~/classes/imports/external.imports';

//******************************************************************************
//  Auth Classes (Guards/Factories)
//******************************************************************************
import { AuthGuard } from '~/core/classes/auth/auth.guard';
// MSAL_TOGGLE_START
import * as auth from '~/core/classes/auth/auth.factories';
const authFactories = new auth.AuthFactories();
const msalProviders = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
    },
    {
        provide: APP_INITIALIZER,
        useFactory: (config: AppConfigService) => () => config.init(),
        deps: [AppConfigService],
        multi: true
    },
    {
        provide: MSAL_INSTANCE,
        useFactory: authFactories.MSALInstanceFactory,
        deps: [AppConfigService]
    },
    {
        provide: MSAL_GUARD_CONFIG,
        useFactory: authFactories.MSALGuardConfigFactory,
        deps: [AppConfigService]
    },
    {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: authFactories.MSALInterceptorConfigFactory,
        deps: [AppConfigService]
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
];
// MSAL_TOGGLE_END

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MsalModule,
        CoreImports,
        CoreRouting,
        AppImports,
        AppRouting,
        ExternalImports,
    ],
    declarations: [
        AppComponent,
    ],
    providers: [
        AppConfigService,
        AuthGuard,
        provideHttpClient(withInterceptorsFromDi()),
        ...msalProviders
    ],
    bootstrap: [
        AppComponent,
        MsalRedirectComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class AppModule { }